__turbopack_context__.v({
  "content": "card-module-scss-module__lXow3W__content",
  "description": "card-module-scss-module__lXow3W__description",
  "footer": "card-module-scss-module__lXow3W__footer",
  "header": "card-module-scss-module__lXow3W__header",
  "root": "card-module-scss-module__lXow3W__root",
  "title": "card-module-scss-module__lXow3W__title",
});
